module.exports = __webpack_public_path__ + "img/bg03.605fa7ad.png";